/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';
import { AfFilter } from 'data/afFilter/afFilter.types';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'view' | 'copy',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
    (clonedTemplate.main as FormTemplateSection).fields.afName.type = 'text';
    (clonedTemplate.main as FormTemplateSection).fields.fgName.type = 'text';
  }

  return clonedTemplate;
}

export function adaptAfFilterCreateTemplate(
  template: any,
  afs: any,
  filterGroups: any,
) {
  const clonedTemplate = cloneDeep(template);
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  const axsgpAfs = afs.filter((af: any) => { return af.type === 'AXSGP' && af.name !== '' });
  const afOptions = axsgpAfs.map((afOption: any) => {
    return { label: afOption.name, value: window.atob(afOption.id) };
  })
  const fgOptions = filterGroups.map((filterGroup: any) => {
    return { label: filterGroup.name, value: filterGroup.fgId }
  });

  if (afOptions.length) {
    (clonedTemplate.main as FormTemplateSection).fields.afName.options = [...afOptions];
    (clonedTemplate.main as FormTemplateSection).fields.afName.initial = afOptions[0].value;
  }

  if (fgOptions.length) {
    (clonedTemplate.main as FormTemplateSection).fields.fgName.options = [...fgOptions];
    (clonedTemplate.main as FormTemplateSection).fields.fgName.initial = fgOptions[0].value;
  }

  return clonedTemplate;
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptAfFilterTemplate(
  template: FormTemplate,
): FormTemplate {

  const clonedTemplate = cloneDeep(template);
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

export function adaptInitialAfFilterFormData(
  afFilter: AfFilter,
): AfFilter {

  const clonedAfFilter = cloneDeep(afFilter);
  return clonedAfFilter;
}
